import React from 'react'

const Exhaust = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 512 512" xmlSpace="preserve" width={width} height={height}>
    <path
      fill="none"
      stroke={color}
      strokeWidth={20}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M71.502 377.173a9.97 9.97 0 0 1-7.071-2.929l-30.168-30.168c-3.905-3.905-3.905-10.237 0-14.143l37.123-37.09 44.892 44.693-37.704 36.707a9.97 9.97 0 0 1-7.072 2.93zM137.356 443.514a9.97 9.97 0 0 1-7.071-2.929l-30.168-30.168c-3.905-3.905-3.905-10.237 0-14.143l37.123-37.09 44.892 44.693-37.704 36.707a9.967 9.967 0 0 1-7.072 2.93z"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth={20}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M201.731 414.28c-5.688 0-11.027-2.207-15.034-6.214L66.692 288.062c-8.29-8.29-8.29-21.778 0-30.068 3.965-3.965 9.255-6.148 14.896-6.148.579 0 1.16.024 1.738.071l139.192-139.191c-.478-6.077 1.646-12.204 6.068-16.626 4.007-4.007 9.346-6.213 15.034-6.213s11.027 2.207 15.034 6.214L378.66 216.105c8.288 8.29 8.289 21.778.001 30.068-3.91 3.909-9.138 6.072-14.733 6.102l-141.061 141.06c-.031 5.49-2.159 10.79-6.102 14.733-4.006 4.005-9.346 6.212-15.034 6.212zM417.088 184.915c-17.781 0-34.591-7.415-48.611-21.444l-27.932-27.924c-6.098-6.098-11.504-9.189-16.068-9.189-.213 0-.425.007-.636.02-3.166.167-5.463 1.77-5.91 2.19a8.723 8.723 0 0 1-.395.374l-12.852 13.154-40.193-40.338 13.412-13.644c10.898-10.792 26.896-17.724 42.86-18.562 1.14-.06 2.298-.09 3.444-.09 14.019 0 35.214 4.483 56.574 25.839l27.935 27.932c2.178 2.178 5.395 4.773 8.361 4.773l.248-.001c1.781-.069 8.069-1.161 18.657-11.75a10.003 10.003 0 0 1 7.071-2.929h0c2.652 0 5.196 1.054 7.071 2.929l26.096 26.097c3.905 3.905 3.905 10.237 0 14.142-18.339 18.338-37.688 27.894-57.509 28.401-.504.015-1.064.02-1.623.02zM112.358 281.726L252.444 141.64"
    />
  </svg>
)
export default Exhaust
